import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { ReactComponent as Arrow } from "../../assets/small-arrow.svg";
import styles from "./styles.module.scss";
import { ReactComponent as Anniversary } from "../../assets/55th-anniversary.svg";
import { ReactComponent as Twitter } from "../../assets/twitter.svg";
import { ReactComponent as Youtube } from "../../assets/youtube.svg";
import { ReactComponent as Instagram } from "../../assets/instagram.svg";
import { ReactComponent as Facebook } from "../../assets/facebook.svg";
import { ReactComponent as LinkedIn } from "../../assets/linkedIn.svg";
import hero from "../../assets/non-member-pic.png";
import Button from "../../custom/button/button";

const NonMemberLayout = () => {
  const navigate = useNavigate();
  return (
    <main>
      <nav className={styles.nav}>
        <div className={styles.groupedNav}>
          <p className={styles.contact}>
            <span>Contact Us:</span>
            <span> 07001237555,</span>
            <span>018880408</span>
          </p>

          <ul className={styles.links}>
            <li>Store</li>
            <li>Contact</li>
            <li>
              <a href="/">Member Portal</a>
            </li>
          </ul>
        </div>
      </nav>

      <section className={styles.belowNav}>
        <div>
          <Anniversary />
        </div>

        <div>
          <ul className={styles.paths}>
            <li>
              About Us <Arrow />
            </li>
            <li>
              Membership <Arrow />
            </li>
            <li>
              Examination <Arrow />
            </li>
            <li>
              News &amp; Events <Arrow />
            </li>
            <li>Trainings</li>
            <li>Sessions</li>
            <li>
              Certification Policies <Arrow />
            </li>
            <li>BoK</li>
          </ul>
        </div>

        <Button text="Become a Member" onClick={() => navigate("/")} />
      </section>

      <img src={hero} className={styles.hero} alt="" />

      <section className={styles.content}>
        <h5 className={styles.news}>NEWS/EVENTS/PROGRAMMES</h5>
        <h1 className={styles.events}>Events & Conferences</h1>
        <h4 className={styles.get}>
          Get the latest information about all our events and Conferences at
          CIPM
        </h4>

        <div className={styles.btnContainer}>
          <NavLink
            to={"/non-member-events/training"}
            className={({ isActive }) =>
              isActive ? styles.activeButton : styles.button
            }
          >
            Trainings
          </NavLink>
          <NavLink
            to={"/non-member-events/conference"}
            className={({ isActive }) =>
              isActive ? styles.activeButton : styles.button
            }
          >
            Conferences
          </NavLink>
          <NavLink
            to={"/non-member-events/other"}
            className={({ isActive }) =>
              isActive ? styles.activeButton : styles.button
            }
          >
            Other Events
          </NavLink>
        </div>

        <Outlet />
      </section>

      <footer className={styles.footer}>
        <section className={styles.footerSection}>
          <h2 className={styles.footerh2}>
            With CIPM, earn respect and <br /> endorsement in the HR <br />{" "}
            industry
          </h2>

          <section className={styles.footerLinks}>
            <div>
              <p className={styles.headP}>Head Office</p>
              <span>
                1 CIPM Avenue, Off Obafemi <br /> Awolowo Way, Opp. Lagos State{" "}
                <br />
                Secretariat, Alausa, Ikeja, <br /> Lagos 07001237555
              </span>
            </div>

            <div>
              <p className={styles.headP}>Quick Links</p>
              <p className={styles.innerP}>Pay your dues</p>
              <p className={styles.innerP}>Pay your dues</p>
              <p className={styles.innerP}>Training</p>
              <p className={styles.innerP}>Online Forum</p>
              <p className={styles.innerP}>Member Portal</p>
              <p className={styles.innerP}>Upgrade Membership</p>
              <p className={styles.innerP}>Print Admission Letter</p>
              <p className={styles.innerP}>Exam Registration</p>
            </div>

            <div>
              <p className={styles.headP}>Popular Pages</p>
              <p className={styles.innerP}>Corper's Application</p>
              <p className={styles.innerP}>Our People</p>
              <p className={styles.innerP}>Membership routes</p>
              <p className={styles.innerP}>Study Centres</p>
            </div>
          </section>
        </section>

        <section className={styles.policySection}>
          <div className={styles.last}>
            <div>
              <p>Copyright @ 2024 CIPM. All Rights Reserved</p>
              <p className={styles.company}>Built by Cyberspace Group</p>
            </div>

            <p>Privacy Policy</p>
          </div>

          <div className={styles.icons}>
            <Facebook />
            <Twitter />
            <Youtube />
            <LinkedIn />
            <Instagram />
          </div>
        </section>
      </footer>
    </main>
  );
};

export default NonMemberLayout;
